var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(true)?_c('Tabs',{attrs:{"itemTabs":_vm.itemTabs,"currentTab":_vm.currentTab},on:{"tabsClick":_vm.onTabsClick}}):_vm._e(),_c('div',{staticClass:"pt-6"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }